module.exports = __webpack_public_path__ + "img/40.5ff67815.png";